<template>
  <RadixModule path="/calls/by-date/calls-by-date" :state=state />
</template>

<script>
  import RadixModule from "RadixModule.vue"
  
  export default {
  
    name: "CallsByDate",
    
    components: {RadixModule},
    
    props: {
      state: Object,
    },
    
    data()
    {
      return {
      }
    },
  }
</script>